import React from 'react'
import { Container, Typography } from '@mui/material'
import ViewFormSubmissionContainer from './containers/ViewFormSubmissionContainer'

const ViewFormSubmissionPage: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Form Submission Details
            </Typography>
            <ViewFormSubmissionContainer />
        </Container>
    )
}

export default ViewFormSubmissionPage 